import React, { Component } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
        };
    }

    componentDidCatch(error, info) {
        this.setState({
            hasError: true,
        });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ position: "absolute", top: "20%", left: "30%", textAlign: "center" }}>
                    <div style={{ fontSize: "80px", color: "red" }}>
                        <FontAwesomeIcon icon={faExclamationTriangle} />
                    </div>
                    <h1>Oops, something went wrong</h1>
                    <h3>Please refresh the page or login to the Application again
                    </h3>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;